import React, { useEffect, useState } from 'react';
import { NavLink } from 'react-router-dom';
import Layout from './Layout';
import { useTheme } from '../context/ThemeContext';
import Swal from 'sweetalert2';
import axios from 'axios';

const SMSBroadcast = () => {
  const { isDark } = useTheme();
  const [stats, setStats] = useState({
    balance: 0,
    used: 0,
    successRate: 0,
    total: 0,
    sent: 0,
    pending: 0,
    failed: 0,
  });

  const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://rccgtr.net/api';

  const fetchStats = async () => {
    try {
      const { data } = await axios.get(`${API_BASE_URL}/sms/stats/broadcast`);
      if (data.success) {
        setStats(data.data);
      } else {
        console.error('Failed to fetch stats:', data.error);
      }
    } catch (err) {
      console.error('Error fetching SMS stats:', err);
    }
  };
  

  useEffect(() => {
    fetchStats();
  }, []);


  return (
    <Layout title="SMS Broadcast">
      <div
        className={`w-full min-h-screen p-6 ${
          isDark ? 'bg-gray-900 text-indigo-100' : 'bg-gray-50 text-gray-900'
        }`}
      >
        <h2 className="text-xl font-bold mb-4">SMS Broadcast</h2>

        {/* Credit Balance Section */}
        <div className="flex flex-col md:flex-row md:items-center gap-4 mb-6">
          {/* Balance Card */}
          <div
            className={`${
              isDark ? 'bg-gray-800 text-indigo-100' : 'bg-white text-gray-900'
            } p-4 shadow rounded border-l-4 ${
              stats.balance < 500 ? 'border-red-500' : 'border-green-500'
            }`}
          >
            <p className="text-sm font-semibold">Credit Balance</p>
            <p
              className={`text-lg font-bold ${
                stats.balance < 500 ? 'text-red-400' : 'text-green-500'
              }`}
            >
              {stats.balance} NG -{' '}
              {stats.balance < 500 ? 'Low Balance' : 'Balance'}
            </p>
          </div>

          {/* Credits Used */}
          <div
            className={`${
              isDark ? 'bg-gray-800 text-indigo-100' : 'bg-white text-gray-900'
            } p-4 shadow rounded border-l-4 border-blue-500`}
          >
            <p className="text-sm font-semibold">Credits Used</p>
            <p className="text-blue-400 text-lg font-bold">
              {stats.used} SMS{' '}
              <span className="text-xs">{stats.successRate}% Success Rate</span>
            </p>
          </div>

          {/* Actions */}
          <div className="flex gap-2 ml-auto">
            <button
              onClick={fetchStats}
              className={`${
                isDark ? 'bg-gray-700 text-indigo-100' : 'bg-gray-200'
              } text-sm px-3 py-1 rounded hover:opacity-90`}
            >
              Refresh Status
            </button>
            <button className="bg-blue-600 text-white px-3 py-1 rounded hover:bg-blue-700">
              View Messages
            </button>
            <NavLink
              to="/composesms"
              className="bg-green-600 text-white px-3 py-1 rounded hover:bg-green-700"
            >
              Compose SMS
            </NavLink>
          </div>
        </div>

        {/* SMS Statistics */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
          <div className={`${isDark ? 'bg-gray-800' : 'bg-white'} shadow rounded p-4`}>
            <p className="text-sm opacity-80">Total SMS</p>
            <p className="text-xl font-bold">{stats.total}</p>
            <p className="text-xs opacity-60">Today’s Messages: {stats.today || 0}</p>
          </div>

          <div className={`${isDark ? 'bg-gray-800' : 'bg-white'} shadow rounded p-4`}>
            <p className="text-sm opacity-80">Sent</p>
            <p className="text-xl font-bold text-green-500">{stats.sent}</p>
            <p className="text-xs opacity-60">Delivered successfully</p>
          </div>

          <div className={`${isDark ? 'bg-gray-800' : 'bg-white'} shadow rounded p-4`}>
            <p className="text-sm opacity-80">Pending</p>
            <p className="text-xl font-bold text-yellow-400">{stats.pending}</p>
          </div>

          <div className={`${isDark ? 'bg-gray-800' : 'bg-white'} shadow rounded p-4`}>
            <p className="text-sm opacity-80">Failed</p>
            <p className="text-xl font-bold text-red-400">{stats.failed}</p>
          </div>
        </div>

        <footer
          className={`mt-10 text-center text-xs ${
            isDark ? 'text-gray-400' : 'text-gray-500'
          }`}
        >
          &copy; 2025 All rights reserved. Church Management System
        </footer>
      </div>
    </Layout>
  );
};

export default SMSBroadcast;
